<div class="modal-backdrop" (click)="closeModal()">
  <div class="experimental-features-panel" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h3>{{ 'experimentalFeatures.title' | translate }}</h3>
        <p>{{ 'experimentalFeatures.subtitle' | translate }}</p>
      </div>
      <button type="button" class="ghost-btn compact" aria-label="Close" (click)="closeModal()">×</button>
    </header>

    <section class="modal-body">
      <p class="empty" *ngIf="!features.length">
        {{ 'experimentalFeatures.empty' | translate }}
      </p>
      <label class="feature-row" *ngFor="let feature of features">
        <div class="feature-row__text">
          <span class="feature-row__label">{{ feature.labelKey | translate }}</span>
          <span class="feature-row__description">{{ feature.descriptionKey | translate }}</span>
        </div>
        <input type="checkbox"
               class="feature-row__toggle"
               [checked]="experimentalFeatures.isEnabled(feature.id)"
               (change)="toggleFeature(feature.id)">
      </label>
    </section>
  </div>
</div>
